import { frontendURL } from 'dashboard/helper/URLHelper';
import AgentModeView from './AgentModeView.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agent-mode'),
    name: 'agent_mode',
    component: AgentModeView,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    children: [
      {
        path: 'conversations/:id',
        name: 'agent_mode_conversation',
        component: AgentModeView,
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
        },
      },
    ],
  },
];
